import { API_URL } from "../../env";
import { ISelectedCustomer } from "../../pages/Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import { ISelectedUserAccount } from "../../pages/Customers/CustomerGroup/Component/AddGroup/Component/AG_Decentralization";
import { EDisplayGroupType } from "../../pages/Customers/CustomerGroup/indexV2";
import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { ICustomer } from "../Customer_V2/customerApi_V2";
import { ISelectOption } from "../selectOption/selectOptionsApi";
import tokenService from '../../services/token';
import axios from "axios";


export interface IGroup {
  id: number
  title: string
  parentId: number
  level: number
  customerCount?: number
  children: IGroupChildren[]
  permissionType: number
}


export interface IGroupChildren {
  id: number
  title: string
  parentId: number
  level: number
  customerCount?: number
  permissionType: number
  children: IGroupChildren[]
}

export interface IGroupTypeList {
  id: number
  title: string
  level: number
  parentId: number
  description?: string
  type: number
  status: number
  adminId: number
  adminName: string
  customerCount: number
  timestamp: string
  children: IGroupTypeList[]
  permissionType: number
}


export interface IDetailGroup {
  id: number
  title: string
  description: string
  type: number
  status: number
  delf: number
  role: number
  parentId: number
  level: number
  adminId: number
  adminName: string
  dateCreate: string
  listCustomer: number[]
  listAdmin: ISelectedUserAccount[]
  infoFilter?: IVConditionFilterV2
  parentTitle?: string
}

//Điều kiện ------------
export interface IOperatorFieldGroupV2 {
  id: number;
  title: string;
  sortOrder: number;
  children: FieldItem[];
}
export interface FieldItem {
  id: number;
  fieldCode: string;
  fieldLabel: string;
  inputType: string;
  type: number
}


export interface IOperatorFieldGroup {
  id: number
  fieldCode: string
  fieldLabel: string
  inputType: string
  type: number
}

export interface IOperatorFieldConditionsGroup {
  id: number
  code: string
  label: string
}

export interface IOperatorFieldValueGroup {
  inputType: 'string' | 'dropdown' | 'date' | 'number'
  type: number
  value: any
}

// export interface Value {
//   value: number
//   label: string
// }

// Interface cho từng điều kiện trong mảng conditions
export interface ICondition {

}

// Interface cho phần tử chính của mảng data
export interface IAddOperatorFieldGroup {
  groupCustomerId: number;
  conditions: {
    logicOperator: string;
    fieldId: number;
    conditionId: number;
    valueText?: string;
    valueNumber?: number;
    valueNumberMin?: number;
    valueNumberMax?: number;
    valueDate?: string;
    valueDateStart?: string;
    valueDateEnd?: string;
    options?: ISelectOption[];
  }[]
}



export const getListGroup = async (
  permittedCategoryCarIds: number[],
  adminId?: number, status?: number, dateStart?: string, dateEnd?: string,
  search?: string, type?: EDisplayGroupType, limit?: number, pageNumber?: number,
  unitTempId?: number,
) => {
  const path = "groupCustomerV2/listGroup"
  const params = {
    permittedCategoryCarIds,
    adminId, status, dateStart, dateEnd,
    search, type, limit, pageNumber,
    unitTempId,
  }
  const result: ResponseSuccessTotal<IGroup[] | IGroupTypeList[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getDetailGroup = async (
  permittedCategoryCarIds: number[], id: number, unitTempId: number
) => {
  const path = "groupCustomerV2/groupDetail"
  const params = {
    permittedCategoryCarIds, id, unitTempId
  }
  const result: ResponseSuccessTotal<IDetailGroup> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const addListGroup = async (
  title: string, type: number, status: number,
  // listCustomer?: ISelectedCustomer[],
  unitScopeId?: number, level?: number, parentId?: number,
  description?: string, listAdmin?: any[], totalCustomer?: number,
  listFilter?: IConditionSync[], manualCustomerIds?: number[], unmatchedCustomerIds?: number[]
) => {
  const url = `groupCustomerV2/addGroup`;
  const params = {
    title, type, status,
    // listCustomer,
    unitScopeId, level, parentId,
    description, listAdmin, totalCustomer,
    listFilter: JSON.stringify(listFilter), manualCustomerIds, unmatchedCustomerIds
  }
  const result: ResponseSuccess<IGroup> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

export const addCustomerByGroup = async (
  listCustomer: ISelectedCustomer[],
  groupCustomerId: number
) => {
  const url = `groupCustomerV2/addCustomerByGroup`;
  const params = {
    listCustomer, groupCustomerId
  }
  const result: ResponseSuccess<IGroup> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Chỉnh sửa nh
export const updateListGroup = async (
  id: number, title: string, type: number, status: number,
  listAdmin?: any[], description?: string, parentId?: number,
  totalCustomer?: number,
  listFilter?: IConditionSync[], manualCustomerIds?: number[], unmatchedCustomerIds?: number[], isCustomerModified?: boolean

) => {
  const url = "groupCustomerV2/editGroup";
  const params = {
    id, title, type, status,
    listAdmin, description, parentId,
    totalCustomer, listFilter: JSON.stringify(listFilter), manualCustomerIds, unmatchedCustomerIds, isCustomerModified
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

export const editCustomerByGroup = async (
  listCustomer: ISelectedCustomer[],
  groupCustomerId: number
) => {
  const url = `groupCustomerV2/editCustomerByGroup`;
  const params = {
    listCustomer, groupCustomerId
  }
  const result: ResponseSuccess<IGroup> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

export const deleteGroup = async (
  id: Number[]
) => {
  const url = `groupCustomerV2/deleteGroup`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}

export const getListAllCustomer = async (
  permittedCategoryCarIds: number[],
  unitScopeId?: Number, listFilter?: IConditionSync[], groupCustomerId?: number, listUnmatchedCustomers?: number[],
  groupCustomerId2?: number
) => {
  const path = "groupCustomerV2/listAllCustomer"
  const params = {
    permittedCategoryCarIds,
    unitScopeId, listFilter: JSON.stringify(listFilter), groupCustomerId, listUnmatchedCustomers,
    groupCustomerId2
  }
  const result: ResponseSuccessTotal<ISelectedCustomer[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getListCustomerByGroup = async (
  permittedCategoryCarIds: number[],
  limit?: number, pageNumber?: number, search?: string, unitScopeId?: number,
  listUnit?: number[], listCategoryCar?: number[], groupCustomerId?: number, typeEditGroup?: number,
  groupCustomerId2?: number, listCustomerManualNoCondition?: number[], lastId?: number, lastPriority?: number
) => {
  const path = "groupCustomerV2/listCustomer"
  const params = {
    permittedCategoryCarIds,
    limit, pageNumber, search, unitScopeId,
    listUnit, listCategoryCar, groupCustomerId, typeEditGroup,
    groupCustomerId2, listCustomerManualNoCondition, lastId, lastPriority
  }
  const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


//V2-------------------------


export interface IVConditionFilterV2 {
  isCustomer?: number
  id?: number
  title?: string
  typeCondition: 0 | 1 | 2  //(0 and, 1 and or)

  conditions: IConditionSV2[]
}

export interface IConditionSV2 {
  id?: number
  logicOperator: 'AND' | 'OR' | 'ALL'
  CustomerField?: CustomerFieldV2
  condition?: ISelectOption // value, label

  //dành cjo phần edit
  isAdd?: boolean
  conditionData?: ISelectOption[]
  optionsData?: ISelectOption[]

  //nơi lưu giá trị
  value?: {
    valueText?: string | null
    valueNumber?: number | null
    valueNumberMin?: number | null
    valueNumberMax?: number | null
    valueDate?: string | null
    valueDayMonthFrom?: string | null
    valueDayMonthTo?: string | null
    valueDateStart?: string | null
    valueDateEnd?: string | null
    options?: ISelectOption[] | null

    valueYear?: string
    valueMonth?: string
    valueDayOnly?: string
    valueMonthYear?: string

    valueDayFrom?: number | null
    valueDayTo?: number | null
    valueMonthFrom?: number | null
    valueMonthTo?: number | null
    valueYearFrom?: number | null
    valueYearTo?: number | null
  } | null
}

export interface CustomerFieldV2 {
  key?: string
  value: number
  label: string
  inputType: string
  type: number
  fieldCode: string
}

export interface IConditionADDAPI {
  isCustomer?: number
  id?: number
  logicOperator: 'AND' | 'OR' | 'ALL'
  fieldId?: number
  conditionId?: number // value, label

  //nơi lưu giá trị
  value?: {
    valueText?: string | null
    valueNumber?: number | null
    valueNumberMin?: number | null
    valueNumberMax?: number | null
    valueDate?: string | null
    valueDayMonthFrom?: string | null
    valueDayMonthTo?: string | null
    valueDateStart?: string | null
    valueDateEnd?: string | null
    options?: any | null,
    // valueDayTo: number | null,
    // valueYearTo: number | null,
    // valueMonthTo: number | null,
    // valueMonthYear: string,
    // valueYear: number | null,
    // valueMonth: number | null,
    // valueDayFrom: number | null,
    // valueDayOnly: number | null,
    // valueYearFrom: number | null,
    // valueMonthFrom: number | null,
  } | null
}

export interface IVConditionFilterADD {
  isCustomer?: number
  id?: number
  title?: string
  typeCondition: 0 | 1 | 2 //(0 and, 1 and or)

  conditions: IConditionADDAPI[]
}


//điều kiện ------------------------------

export const getListOperatorFieldGroup = async (
  search?: string
) => {
  const path = "groupCustomerV2/listFieldGroup"
  const params = {
    search
  }
  const result: ResponseSuccess<IOperatorFieldGroupV2[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

export const getListOperatorFieldConditionsGroup = async (
  id: number
) => {
  const path = "groupCustomerV2/listFieldConditions"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IOperatorFieldConditionsGroup[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};


export const getListOperatorFieldValueGroup = async (
  fieldId: number, conditionId: number, listFilter: IConditionSync[], listUnit: number,
  limit: number = 1000000, pageNumber: number = 1
) => {
  const path = "groupCustomerV2/fieldValue"
  const params = {
    fieldId, conditionId, listFilter: JSON.stringify(listFilter), listUnit: [listUnit],
    limit, pageNumber
  }
  const result: ResponseSuccessTotal<IOperatorFieldValueGroup> = await axiosClient.get(
    path, { params }
  );
  return result;
};


//Thêm mới điều kiện  vào nhóm khách hàng thành công
// export const addOperatorFilterGroup = async (
//   groupCustomerId: number, listFilterGroup: IVConditionFilterADD[]
// ) => {
//   const url = `groupCustomerV2/addFilterGroup`;
//   const params = {
//     groupCustomerId,
//     listFilterGroup
//   }
//   const result: ResponseSuccess<[]> = await axiosClient.post(
//     url, params
//   );
//   return result;
// }
export const addOperatorFilterGroup = async (
  groupCustomerId: number,
  listFilterGroup: IVConditionFilterADD[]
) => {
  const url = `groupCustomerV2/addFilterGroup`;
  const params = {
    groupCustomerId,
    listFilterGroup
  };

  const result: ResponseSuccess<[]> = await axiosClient.post(url, params, {
    headers: {
      "Content-Type": "application/json"
    }
  });

  return result;
};

//Sửa điều kiện  vào nhóm khách hàng thành công
export const updateOperatorFilterGroup = async (
  groupCustomerId: number, listFilterGroup: IVConditionFilterADD[]
) => {
  const url = `groupCustomerV2/editFilterGroup`;
  const params = {
    groupCustomerId,
    listFilterGroup
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(url, params, {
    headers: {
      "Content-Type": "application/json"
    }
  });
  return result;
}

// bộ lọc =------------
export const addFilter = async (
  listFilter: IVConditionFilterADD[]
) => {
  const url = `groupCustomerV2/addFilter`;
  const params = {
    listFilter
  }
  const result: ResponseSuccess<{ id: number }> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

//Thông tin bộ lọc.
export const getInfoOperatorFieldConditionsGroup = async (
  id: number
) => {
  const path = "groupCustomerV2/infoFilter"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<IVConditionFilterV2> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Đồng bộ dữ liệu khách hàng (mỗi khách hàng gồm nhiều recordId)
export const getListCustomer_V2BySync = async (
  limit: number = 20, pageNumber: number = 1, listUnit?: number[], listCategoryCar?: number[],
  search?: string, groupCustomerId?: number, listCustomer?: number[], isMatched?: number,
  listUnmatchedCustomers?: number[]

) => {
  const path = `groupCustomerV2/listCustomer_V2`;
  const params = {
    limit, pageNumber, listUnit, listCategoryCar,
    search, groupCustomerId, listCustomer, isMatched,
    listUnmatchedCustomers
  }
  const result: ResponseSuccessTotal<ICustomer[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Mới --------------------------------------------------

export interface IConditionSync {
  logicOperator: 'AND' | 'OR' | 'ALL'
  CustomerField?: CustomerFieldV2
  condition?: ISelectOption // value, label


  //nơi lưu giá trị
  value?: {
    valueText?: string | null
    valueNumber?: number | null
    valueNumberMin?: number | null
    valueNumberMax?: number | null
    valueDate?: string | null
    valueDateStart?: string | null
    valueDateEnd?: string | null
    options?: ISelectOption[] | null
  } | null
}

// interface IConditionPreview {
//   dataMatched: ICustomer[]
//   dataUnmatched: ICustomer[]
//   totalMatched: number,
//   totalUnmatched: number
// }

interface IConditionMatched {
  dataMatched: ICustomer[]
  totalMatched: number,
}

interface IConditionUnMatched {
  dataUnmatched: ICustomer[]
  totalUnmatched: number
}

export interface IPositionGroup {
  id: number
  children?: IPositionGroup[]
}

// export const getListConditionPreview = async (
//   listFilter: IConditionSync[],
//   limit: number = 20, pageNumber: number = 1, search?: string, unitScopeId?: number,
//   groupCustomerId?: number, listUnmatchedCustomers?: number[], listUnit?: number[], listCategoryCar?: number[],
// ) => {
//   const path = `groupCustomerV2/listConditionMatched`;
//   const params = {
//     listFilter: JSON.stringify(listFilter),
//     limit, pageNumber, search, unitScopeId,
//     groupCustomerId, listUnmatchedCustomers, listUnit, listCategoryCar
//   }
//   const result: ResponseSuccess<IConditionPreview> = await axiosClient.get(
//     path, { params }
//   );
//   return result;
// };

export const getListConditionMatched = async (
  permittedCategoryCarIds: number[], listFilter: IConditionSync[],
  limit: number = 20, pageNumber: number = 1, search?: string, unitScopeId?: number,
  groupCustomerId?: number, listUnmatchedCustomers?: number[], listUnit?: number[], listCategoryCar?: number[],
  lastId?: number
) => {
  const path = `groupCustomerV2/listConditionMatched`;
  const params = {
    permittedCategoryCarIds, listFilter: JSON.stringify(listFilter),
    limit, pageNumber, search, unitScopeId,
    groupCustomerId, listUnmatchedCustomers, listUnit, listCategoryCar,
    lastId
  }
  const result: ResponseSuccess<IConditionMatched> = await axiosClient.get(
    path, { params }
  );
  return result;
};

let _abortControllerListConditionUnMatched: AbortController | null = null;

export const getListConditionUnMatched = async (
  permittedCategoryCarIds: number[], listFilter: IConditionSync[],
  limit: number = 20, pageNumber: number = 1, search?: string, unitScopeId?: number,
  groupCustomerId?: number, listUnmatchedCustomers?: number[], listUnit?: number[], listCategoryCar?: number[],
  lastId?: number
) => {
  if (_abortControllerListConditionUnMatched) {
    _abortControllerListConditionUnMatched.abort();
  }
  _abortControllerListConditionUnMatched = new AbortController();

  const path = `groupCustomerV2/listConditionUnMatched`;
  const params = {
    permittedCategoryCarIds, listFilter: JSON.stringify(listFilter),
    limit, pageNumber, search, unitScopeId,
    groupCustomerId, listUnmatchedCustomers, listUnit, listCategoryCar,
    lastId
  }
  try {
    const result: ResponseSuccess<IConditionUnMatched> = await axiosClient.get(
      path, { params, signal: _abortControllerListConditionUnMatched.signal }
    );
    return result;
  } catch (error) {
    if (axios.isCancel(error)) return null as any;
    throw error;
  }
};


//	Cập nhật vị trí nhóm khách hàng thành công /groupCustomerV2/updatePosition
export const updatePositionGroup = async (
  positionGroup: IPositionGroup[]
) => {
  const url = "groupCustomerV2/updatePosition";
  const params = {
    data: JSON.stringify(positionGroup)
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

export const exportListGroupCustomerExcel = async (
  groupCustomerId: number, unitScopeId: number, title: string, type?: number
) => {
  try {
    // 1. Kiểm tra URL
    const token = tokenService.getToken()
    const apiUrl = `${API_URL}${"groupCustomerV2/exportExcel"}`

    const response = await axios.get(apiUrl, {
      params: {
        groupCustomerId, unitScopeId, title, type
      },
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });

    if (response.status === 200 && response.data) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${title}.xlsx`;
      a.click();
    }

  } catch (error) {
    console.error('Error:', error);
  }

};